import type { NUtils } from '@app/types/Utils';

export const getSelectItemByValue: NUtils.GetSelectItemByValue = (
  value,
  data
) => {
  if (data) {
    return data.find(({ value: _value }) => _value === value) || {};
  } else {
    return {};
  }
};
